<div class="back-button">
	<div [routerLink]="route()">
		<mat-icon>arrow_back</mat-icon>
		<span>{{ 'common.back' | translate | uppercase }}</span>
	</div>
</div>
